function paymentEntity() {
    if (!document.querySelector('.js-payment-entity') && !document.querySelector('.js-payment-installment-plan')) return;

    document.addEventListener('click', (e) => {
        const target = (
            e.target.closest('.js-payment-entity') ||
            e.target.closest('.js-payment-installment-plan')
        );

        if (!target) return;

        modals.closeModal();

        if (target.classList.contains('js-payment-entity')) {
            modals.openModal(null, '#change-payment-entity', modalOpenCallback);
        } else if (target.classList.contains('js-payment-installment-plan')) {
            modals.openModal(null, '#installment-plan', modalOpenCallback);
        }
    })

    function modalOpenCallback(modal) {
        modal.addEventListener('closemodal', (e) => {
            modals.openModal(null, '#payment-change')
        })
    }
}
